/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateCardDto
 */
export interface CreateUpdateCardDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    number?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCardDto
     */
    pass?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    justification?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateCardDto
     */
    postDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    interview?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    intellectualAbility?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    personality: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    psychomotorEfficiency: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    conclusions: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    recommendations: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    examId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    psychologistUID?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateCardDto
     */
    cardDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    pdfTemplateType?: CreateUpdateCardDtoPdfTemplateTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalSkin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalSkull?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalLymphNodes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalNose?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalOropharyngealCavity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalNeck?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalChest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalLungs?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalCardiovascularSystem?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalAbdominalCavity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalGenitourinarySystem?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalLocomotorSystem?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalNervousSystem?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    physicalMentalState?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateCardDto
     */
    nextExamDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    type?: CreateUpdateCardDtoTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    eyeball?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    facialAssymetry?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    breathMurmur?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    regularity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    heartSounds?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    heartRate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    restRR?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    hernias?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    liver?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    muscleStrengthUpper?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    handGrip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    limitationFingers?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    limitationElbows?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    limitationShoulder?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    limitationFeet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    limitationKnee?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    movementCervical?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    movementLumbar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    anomalies?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    upperLimbParalysis?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    lowerLimbParalysis?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    muscleAtrophy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    gaitTest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    externalAppearance?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    behaviorTesting?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    generalMood?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    levelOfInterest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    attitudeToPsychologist?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    abilityToExpressYourself?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    selfControl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    reactionToFailure?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    understandingTheInstructions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    attention?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    workPace?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    arousalLevel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    behaviorUnderPressure?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCardDto
     */
    twilightVision?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCardDto
     */
    glareSensitivity?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCardDto
     */
    verified?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCardDto
     */
    withoutSign?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCardDto
     */
    examFrequencyChange?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    examFrequencyChangeJustification?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    weight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    height?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    pulse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    bp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    eyeRight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    eyeLeft?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    colorRecognition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    squint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    fieldOfVisionRight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    fieldOfVisionLeft?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    hearingRight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateCardDto
     */
    hearingLeft?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCardDto
     */
    romberg?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCardDto
     */
    nystagmus?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateCardDto
     */
    generatedByAutomat?: boolean | null;
}


/**
 * @export
 */
export const CreateUpdateCardDtoPdfTemplateTypeEnum = {
    art_82_ust_1: 'art_82_ust_1',
    art_82_uprzywilejowany: 'art_82_uprzywilejowany',
    art_82_instruktor_egzaminator: 'art_82_instruktor_egzaminator',
    art_39_transport_drogowy: 'art_39_transport_drogowy',
    medycyna_pracy: 'medycyna_pracy',
    karta_badania_psychologicznego: 'karta_badania_psychologicznego',
    karta_broni: 'karta_broni',
    bron_orzeczenie_lekarskie: 'bron_orzeczenie_lekarskie',
    bron_orzeczenie_psychologiczne: 'bron_orzeczenie_psychologiczne',
    bron_karta_badania_psychologicznego: 'bron_karta_badania_psychologicznego',
    karta_badania_profilaktycznego: 'karta_badania_profilaktycznego',
    mp_orzeczenie_lekarskie_43: 'mp_orzeczenie_lekarskie_43',
    mp_orzeczenie_lekarskie_43_ang: 'mp_orzeczenie_lekarskie_43_ang',
    mp_orzeczenie_lekarskie_43_transport: 'mp_orzeczenie_lekarskie_43_transport',
    kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany: 'kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany',
    kierowca_orzeczenie_lekarskie_art_75_reszta: 'kierowca_orzeczenie_lekarskie_art_75_reszta',
    mp_zaswiadczenie_lekarskie_student: 'mp_zaswiadczenie_lekarskie_student',
    orzeczenie_sanitarno_epidemiologiczne: 'orzeczenie_sanitarno_epidemiologiczne',
    karta_badania_kierowcy: 'karta_badania_kierowcy',
    konsultacja_neurologiczna: 'konsultacja_neurologiczna',
    konsultacja_laryngologiczna: 'konsultacja_laryngologiczna',
    konsultacja_okulistyczna: 'konsultacja_okulistyczna',
    konsultacja_psychiatryczna: 'konsultacja_psychiatryczna',
    karta_odpowiedzi: 'karta_odpowiedzi',
    karta_badania_sanitarno_epidemiologicznego: 'karta_badania_sanitarno_epidemiologicznego',
    zaswiadczenie_lekarskie_zdolnosci_do_pracy: 'zaswiadczenie_lekarskie_zdolnosci_do_pracy',
    zaswiadczenie_sportowe: 'zaswiadczenie_sportowe',
    karta_badania_sportowego: 'karta_badania_sportowego',
    orzeczenie_stan_zdrowia_lekarza: 'orzeczenie_stan_zdrowia_lekarza',
    zaswiadczenie_stan_zdrowia_pielegniarka: 'zaswiadczenie_stan_zdrowia_pielegniarka',
    zaswiadczenie_stan_zdrowia_pielegniarka_art31: 'zaswiadczenie_stan_zdrowia_pielegniarka_art31',
    rejestrOrzeczen: 'rejestrOrzeczen',
    rejestrMedycynaPracy: 'rejestrMedycynaPracy',
    rejestrKierowcow: 'rejestrKierowcow',
    rejestrUczniowieStudenci: 'rejestrUczniowieStudenci',
    skierowanie_uczen: 'skierowanie_uczen',
    skierowanie_uczen_sanitarne: 'skierowanie_uczen_sanitarne',
    skierowanie_pracownik: 'skierowanie_pracownik',
    skierowanie_pracownik_sanitarne: 'skierowanie_pracownik_sanitarne',
    wynik_widzenia_zmierzchowego: 'wynik_widzenia_zmierzchowego',
    wybuch_cywilne_orzeczenie_lekarskie: 'wybuch_cywilne_orzeczenie_lekarskie',
    wybuch_cywilne_orzeczenie_psychologiczne: 'wybuch_cywilne_orzeczenie_psychologiczne',
    wybuch_wojsko_orzeczenie_lekarskie: 'wybuch_wojsko_orzeczenie_lekarskie',
    wybuch_wojsko_orzeczenie_psychologiczne: 'wybuch_wojsko_orzeczenie_psychologiczne',
    detektyw_orzeczenie_lekarskie: 'detektyw_orzeczenie_lekarskie',
    detektyw_orzeczenie_psychologiczne: 'detektyw_orzeczenie_psychologiczne',
    zestawienie_orzeczen: 'zestawienie_orzeczen',
    lista_firm: 'lista_firm',
    skierowanie_do_poradni: 'skierowanie_do_poradni',
    strazak_orzeczenie_lekarskie: 'strazak_orzeczenie_lekarskie',
    kierowca_rajdowy_orzeczenie_psychologiczne: 'kierowca_rajdowy_orzeczenie_psychologiczne',
    nauczyciel_poratowanie_zdrowia: 'nauczyciel_poratowanie_zdrowia',
    zaswiadczenie_okulary: 'zaswiadczenie_okulary',
    faktura_pl: 'faktura_pl',
    korekta_pl: 'korekta_pl'
} as const;
export type CreateUpdateCardDtoPdfTemplateTypeEnum = typeof CreateUpdateCardDtoPdfTemplateTypeEnum[keyof typeof CreateUpdateCardDtoPdfTemplateTypeEnum];

/**
 * @export
 */
export const CreateUpdateCardDtoTypeEnum = {
    Preventive: 'Preventive',
    Psychologist: 'Psychologist',
    PsychologistWeapon: 'PsychologistWeapon',
    Weapon: 'Weapon',
    Driver: 'Driver',
    Sanitary: 'Sanitary',
    Sport: 'Sport'
} as const;
export type CreateUpdateCardDtoTypeEnum = typeof CreateUpdateCardDtoTypeEnum[keyof typeof CreateUpdateCardDtoTypeEnum];


/**
 * Check if a given object implements the CreateUpdateCardDto interface.
 */
export function instanceOfCreateUpdateCardDto(value: object): value is CreateUpdateCardDto {
    if (!('personality' in value) || value['personality'] === undefined) return false;
    if (!('psychomotorEfficiency' in value) || value['psychomotorEfficiency'] === undefined) return false;
    if (!('conclusions' in value) || value['conclusions'] === undefined) return false;
    if (!('recommendations' in value) || value['recommendations'] === undefined) return false;
    return true;
}

export function CreateUpdateCardDtoFromJSON(json: any): CreateUpdateCardDto {
    return CreateUpdateCardDtoFromJSONTyped(json, false);
}

export function CreateUpdateCardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateCardDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'pass': json['pass'] == null ? undefined : json['pass'],
        'justification': json['justification'] == null ? undefined : json['justification'],
        'postDate': json['postDate'] == null ? undefined : (new Date(json['postDate'])),
        'interview': json['interview'] == null ? undefined : json['interview'],
        'intellectualAbility': json['intellectualAbility'] == null ? undefined : json['intellectualAbility'],
        'personality': json['personality'],
        'psychomotorEfficiency': json['psychomotorEfficiency'],
        'conclusions': json['conclusions'],
        'recommendations': json['recommendations'],
        'examId': json['examId'] == null ? undefined : json['examId'],
        'psychologistUID': json['psychologistUID'] == null ? undefined : json['psychologistUID'],
        'cardDate': json['cardDate'] == null ? undefined : (new Date(json['cardDate'])),
        'pdfTemplateType': json['pdfTemplateType'] == null ? undefined : json['pdfTemplateType'],
        'physicalSkin': json['physicalSkin'] == null ? undefined : json['physicalSkin'],
        'physicalSkull': json['physicalSkull'] == null ? undefined : json['physicalSkull'],
        'physicalLymphNodes': json['physicalLymphNodes'] == null ? undefined : json['physicalLymphNodes'],
        'physicalNose': json['physicalNose'] == null ? undefined : json['physicalNose'],
        'physicalOropharyngealCavity': json['physicalOropharyngealCavity'] == null ? undefined : json['physicalOropharyngealCavity'],
        'physicalNeck': json['physicalNeck'] == null ? undefined : json['physicalNeck'],
        'physicalChest': json['physicalChest'] == null ? undefined : json['physicalChest'],
        'physicalLungs': json['physicalLungs'] == null ? undefined : json['physicalLungs'],
        'physicalCardiovascularSystem': json['physicalCardiovascularSystem'] == null ? undefined : json['physicalCardiovascularSystem'],
        'physicalAbdominalCavity': json['physicalAbdominalCavity'] == null ? undefined : json['physicalAbdominalCavity'],
        'physicalGenitourinarySystem': json['physicalGenitourinarySystem'] == null ? undefined : json['physicalGenitourinarySystem'],
        'physicalLocomotorSystem': json['physicalLocomotorSystem'] == null ? undefined : json['physicalLocomotorSystem'],
        'physicalNervousSystem': json['physicalNervousSystem'] == null ? undefined : json['physicalNervousSystem'],
        'physicalMentalState': json['physicalMentalState'] == null ? undefined : json['physicalMentalState'],
        'nextExamDate': json['nextExamDate'] == null ? undefined : (new Date(json['nextExamDate'])),
        'type': json['type'] == null ? undefined : json['type'],
        'eyeball': json['eyeball'] == null ? undefined : json['eyeball'],
        'facialAssymetry': json['facialAssymetry'] == null ? undefined : json['facialAssymetry'],
        'breathMurmur': json['breathMurmur'] == null ? undefined : json['breathMurmur'],
        'regularity': json['regularity'] == null ? undefined : json['regularity'],
        'heartSounds': json['heartSounds'] == null ? undefined : json['heartSounds'],
        'heartRate': json['heartRate'] == null ? undefined : json['heartRate'],
        'restRR': json['restRR'] == null ? undefined : json['restRR'],
        'hernias': json['hernias'] == null ? undefined : json['hernias'],
        'liver': json['liver'] == null ? undefined : json['liver'],
        'muscleStrengthUpper': json['muscleStrengthUpper'] == null ? undefined : json['muscleStrengthUpper'],
        'handGrip': json['handGrip'] == null ? undefined : json['handGrip'],
        'limitationFingers': json['limitationFingers'] == null ? undefined : json['limitationFingers'],
        'limitationElbows': json['limitationElbows'] == null ? undefined : json['limitationElbows'],
        'limitationShoulder': json['limitationShoulder'] == null ? undefined : json['limitationShoulder'],
        'limitationFeet': json['limitationFeet'] == null ? undefined : json['limitationFeet'],
        'limitationKnee': json['limitationKnee'] == null ? undefined : json['limitationKnee'],
        'movementCervical': json['movementCervical'] == null ? undefined : json['movementCervical'],
        'movementLumbar': json['movementLumbar'] == null ? undefined : json['movementLumbar'],
        'anomalies': json['anomalies'] == null ? undefined : json['anomalies'],
        'upperLimbParalysis': json['upperLimbParalysis'] == null ? undefined : json['upperLimbParalysis'],
        'lowerLimbParalysis': json['lowerLimbParalysis'] == null ? undefined : json['lowerLimbParalysis'],
        'muscleAtrophy': json['muscleAtrophy'] == null ? undefined : json['muscleAtrophy'],
        'gaitTest': json['gaitTest'] == null ? undefined : json['gaitTest'],
        'externalAppearance': json['externalAppearance'] == null ? undefined : json['externalAppearance'],
        'behaviorTesting': json['behaviorTesting'] == null ? undefined : json['behaviorTesting'],
        'generalMood': json['generalMood'] == null ? undefined : json['generalMood'],
        'levelOfInterest': json['levelOfInterest'] == null ? undefined : json['levelOfInterest'],
        'attitudeToPsychologist': json['attitudeToPsychologist'] == null ? undefined : json['attitudeToPsychologist'],
        'abilityToExpressYourself': json['abilityToExpressYourself'] == null ? undefined : json['abilityToExpressYourself'],
        'selfControl': json['selfControl'] == null ? undefined : json['selfControl'],
        'reactionToFailure': json['reactionToFailure'] == null ? undefined : json['reactionToFailure'],
        'understandingTheInstructions': json['understandingTheInstructions'] == null ? undefined : json['understandingTheInstructions'],
        'attention': json['attention'] == null ? undefined : json['attention'],
        'workPace': json['workPace'] == null ? undefined : json['workPace'],
        'arousalLevel': json['arousalLevel'] == null ? undefined : json['arousalLevel'],
        'behaviorUnderPressure': json['behaviorUnderPressure'] == null ? undefined : json['behaviorUnderPressure'],
        'twilightVision': json['twilightVision'] == null ? undefined : json['twilightVision'],
        'glareSensitivity': json['glareSensitivity'] == null ? undefined : json['glareSensitivity'],
        'verified': json['verified'] == null ? undefined : json['verified'],
        'withoutSign': json['withoutSign'] == null ? undefined : json['withoutSign'],
        'examFrequencyChange': json['examFrequencyChange'] == null ? undefined : json['examFrequencyChange'],
        'examFrequencyChangeJustification': json['examFrequencyChangeJustification'] == null ? undefined : json['examFrequencyChangeJustification'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'height': json['height'] == null ? undefined : json['height'],
        'pulse': json['pulse'] == null ? undefined : json['pulse'],
        'bp': json['bp'] == null ? undefined : json['bp'],
        'eyeRight': json['eyeRight'] == null ? undefined : json['eyeRight'],
        'eyeLeft': json['eyeLeft'] == null ? undefined : json['eyeLeft'],
        'colorRecognition': json['colorRecognition'] == null ? undefined : json['colorRecognition'],
        'squint': json['squint'] == null ? undefined : json['squint'],
        'fieldOfVisionRight': json['fieldOfVisionRight'] == null ? undefined : json['fieldOfVisionRight'],
        'fieldOfVisionLeft': json['fieldOfVisionLeft'] == null ? undefined : json['fieldOfVisionLeft'],
        'hearingRight': json['hearingRight'] == null ? undefined : json['hearingRight'],
        'hearingLeft': json['hearingLeft'] == null ? undefined : json['hearingLeft'],
        'romberg': json['romberg'] == null ? undefined : json['romberg'],
        'nystagmus': json['nystagmus'] == null ? undefined : json['nystagmus'],
        'generatedByAutomat': json['generatedByAutomat'] == null ? undefined : json['generatedByAutomat'],
    };
}

export function CreateUpdateCardDtoToJSON(value?: CreateUpdateCardDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
        'pass': value['pass'],
        'justification': value['justification'],
        'postDate': value['postDate'] == null ? undefined : ((value['postDate'] as any).toISOString()),
        'interview': value['interview'],
        'intellectualAbility': value['intellectualAbility'],
        'personality': value['personality'],
        'psychomotorEfficiency': value['psychomotorEfficiency'],
        'conclusions': value['conclusions'],
        'recommendations': value['recommendations'],
        'examId': value['examId'],
        'psychologistUID': value['psychologistUID'],
        'cardDate': value['cardDate'] == null ? undefined : ((value['cardDate'] as any).toISOString()),
        'pdfTemplateType': value['pdfTemplateType'],
        'physicalSkin': value['physicalSkin'],
        'physicalSkull': value['physicalSkull'],
        'physicalLymphNodes': value['physicalLymphNodes'],
        'physicalNose': value['physicalNose'],
        'physicalOropharyngealCavity': value['physicalOropharyngealCavity'],
        'physicalNeck': value['physicalNeck'],
        'physicalChest': value['physicalChest'],
        'physicalLungs': value['physicalLungs'],
        'physicalCardiovascularSystem': value['physicalCardiovascularSystem'],
        'physicalAbdominalCavity': value['physicalAbdominalCavity'],
        'physicalGenitourinarySystem': value['physicalGenitourinarySystem'],
        'physicalLocomotorSystem': value['physicalLocomotorSystem'],
        'physicalNervousSystem': value['physicalNervousSystem'],
        'physicalMentalState': value['physicalMentalState'],
        'nextExamDate': value['nextExamDate'] == null ? undefined : ((value['nextExamDate'] as any).toISOString()),
        'type': value['type'],
        'eyeball': value['eyeball'],
        'facialAssymetry': value['facialAssymetry'],
        'breathMurmur': value['breathMurmur'],
        'regularity': value['regularity'],
        'heartSounds': value['heartSounds'],
        'heartRate': value['heartRate'],
        'restRR': value['restRR'],
        'hernias': value['hernias'],
        'liver': value['liver'],
        'muscleStrengthUpper': value['muscleStrengthUpper'],
        'handGrip': value['handGrip'],
        'limitationFingers': value['limitationFingers'],
        'limitationElbows': value['limitationElbows'],
        'limitationShoulder': value['limitationShoulder'],
        'limitationFeet': value['limitationFeet'],
        'limitationKnee': value['limitationKnee'],
        'movementCervical': value['movementCervical'],
        'movementLumbar': value['movementLumbar'],
        'anomalies': value['anomalies'],
        'upperLimbParalysis': value['upperLimbParalysis'],
        'lowerLimbParalysis': value['lowerLimbParalysis'],
        'muscleAtrophy': value['muscleAtrophy'],
        'gaitTest': value['gaitTest'],
        'externalAppearance': value['externalAppearance'],
        'behaviorTesting': value['behaviorTesting'],
        'generalMood': value['generalMood'],
        'levelOfInterest': value['levelOfInterest'],
        'attitudeToPsychologist': value['attitudeToPsychologist'],
        'abilityToExpressYourself': value['abilityToExpressYourself'],
        'selfControl': value['selfControl'],
        'reactionToFailure': value['reactionToFailure'],
        'understandingTheInstructions': value['understandingTheInstructions'],
        'attention': value['attention'],
        'workPace': value['workPace'],
        'arousalLevel': value['arousalLevel'],
        'behaviorUnderPressure': value['behaviorUnderPressure'],
        'twilightVision': value['twilightVision'],
        'glareSensitivity': value['glareSensitivity'],
        'verified': value['verified'],
        'withoutSign': value['withoutSign'],
        'examFrequencyChange': value['examFrequencyChange'],
        'examFrequencyChangeJustification': value['examFrequencyChangeJustification'],
        'comment': value['comment'],
        'weight': value['weight'],
        'height': value['height'],
        'pulse': value['pulse'],
        'bp': value['bp'],
        'eyeRight': value['eyeRight'],
        'eyeLeft': value['eyeLeft'],
        'colorRecognition': value['colorRecognition'],
        'squint': value['squint'],
        'fieldOfVisionRight': value['fieldOfVisionRight'],
        'fieldOfVisionLeft': value['fieldOfVisionLeft'],
        'hearingRight': value['hearingRight'],
        'hearingLeft': value['hearingLeft'],
        'romberg': value['romberg'],
        'nystagmus': value['nystagmus'],
        'generatedByAutomat': value['generatedByAutomat'],
    };
}

